import { render, staticRenderFns } from "./ConfirmaEntrega.vue?vue&type=template&id=60ec3632&scoped=true"
import script from "./ConfirmaEntrega.vue?vue&type=script&lang=js"
export * from "./ConfirmaEntrega.vue?vue&type=script&lang=js"
import style0 from "./ConfirmaEntrega.vue?vue&type=style&index=0&id=60ec3632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec3632",
  null
  
)

export default component.exports